/*
Generic Store for key/value pairs.

Actions:
- store    payload={ key: , value: }
- remove payload={ key: }
- clear  payload = {}
*/

import { createSlice } from '@reduxjs/toolkit';

const initialValuesState = { values: {} };

const keyValueStore = createSlice({
  name: 'keyValueStore',
  initialState: initialValuesState,
  reducers: {
    store(state, action) {
      state.values[action.payload.key] = action.payload.value;
    },
    remove(state, action) {
      delete state.values[action.payload.key];
    },
    clear(state) {
      state.values = {};
    }
  }
});

export const keyValueStoreActions = keyValueStore.actions;

export default keyValueStore.reducer;